import { Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-activity-panel',
  standalone: true,
  imports: [DatePipe, RouterModule],
  templateUrl: './activity-panel.component.html',
  styleUrl: './activity-panel.component.scss'
})
export class ActivityPanelComponent {
  readonly activities = inject(UserService).select('activity');
}
